import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import classNames from "classnames"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCategoriesAndSubCategories as onGetCategoriesAndSubCategories } from "store/products/actions"
import { resetErrorAndResp } from "store/products/actions"
import { deleteItemDirect as onDeleteItemDirect } from "helpers/backend_helper"
import Loader from "components/Common/Loader"

const CategorySubCategoryList = props => {
  const dispatch = useDispatch()

  const { categorySubCategory, response, error, deleteInProgress} = useSelector(state => ({
    categorySubCategory: state.Products.categories,

    response: state.Products.response,
    error: state.Products.error,
    deleteInProgress: state.Products.deleteInProgress
  }))

  const [categorySubCategoryList, setCategorySubCategoryList] = useState([])

  const [isEdit, setIsEdit] = useState(false)

  const [newItemToAdd, setNewItemToAdd] = useState()
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [detailsForEdit, setDetailsForEdit] = useState()
  const [showDeletePopUp, setShowDeletePopUp] = useState(false)
  const [deleteMessage, setDeleteMessage] = useState('')
  const [itemToDelete, setItemToDelete] = useState()
  const [showLoading, setShowLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  
  function addNewItem(item) {
    dispatch(resetErrorAndResp())
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }
  const onDrawerClose = () => {
    setOpen(false);
  }
  const onNewlyAddedValue = (value) => {
    if(value > 0){
      //showSuccessToast('Edited Successfully!!!')
    }
  }
  //pagination customization
  const pageOptions = {
    sizePerPage: 10,
    totalSize: categorySubCategoryList.length, // replace later with size(orders),
    custom: true,
    onPageChange: (page, sizePerPage) => {
      setCurrentPage(page)
    }
  }
  const { SearchBar } = Search


  const CategorySubCategoryColumns = () => [
    {
      dataField: "categoryId",
      text: "Category ID",
      sort: true,
      formatter: (cellContent, row) => (
        <div className="text-body fw-bold">
          {row?.categoryId}
        </div>
      ),
    },
    {
      dataField: "categoryName",
      text: "Category Name",
      sort: true,
    },
    {
      dataField: "subCategoryId",
      text: "Sub Category ID",
      sort: true,
    },
    {
      dataField: "subCategoryName",
      text: "Sub Category Name",
      sort: true,
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, product) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleEditClick(product)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => handleDeleteClick(product)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  useEffect(() => {
    dispatch(onGetCategoriesAndSubCategories(true))
  }, [dispatch]);

  useEffect(() => {
    let tempArray = [];
    let counter = 1;
    for (const [key, value] of Object.entries(categorySubCategory)) {
      tempArray.push({
        id:counter,
        categoryId:value.categoryId,
        categoryName:value.categoryName
      })
      counter++;
      if(value.subCategoryList && value.subCategoryList.length > 0){
        value.subCategoryList.forEach(subCat => {
          tempArray.push({
            id:counter,
            categoryId:value.categoryId,
            categoryName:value.categoryName,
            subCategoryId:subCat.categoryId,
            subCategoryName:subCat.categoryName
          })
          counter++;
        });
      }
    }
    setCategorySubCategoryList(tempArray)
  }, [categorySubCategory])

  const handleEditClick = arg =>{
    setDetailsForEdit(arg)
    setIsEdit(true)
    if(arg?.subCategoryId){
      addNewItem('Sub Category')
    }
    else{
      addNewItem('Category')
    }
  }

  const handleDeleteClick = arg => {
   // dispatch(onDeleteOrder(order))
   setItemToDelete(arg)
   if(arg?.subCategoryId){
    setDeleteMessage('Deleting Sub Category : '+arg.subCategoryName)
   }
   else{
    setDeleteMessage('Deleting Category : '+arg.categoryName)
   }
    setShowDeletePopUp(true)
  }

  const confirmDelete = async () =>{
    setShowDeletePopUp(false)
    setShowLoading(true)
    const response =  await onDeleteItemDirect({
      'key': itemToDelete?.subCategoryId? itemToDelete?.subCategoryId : itemToDelete.categoryId,
      'value' : itemToDelete?.subCategoryId? 'Sub Category' : 'Category'
    }, '')
    setShowLoading(false)
    if(response.status == 'success'){
      dispatch(onGetCategoriesAndSubCategories(false))
      if(isEdit===true){
        showSuccessToast('Edited Successfully!!!')
      }
      else{
        showSuccessToast('Deleted Successfully!!!')
      }
    }
  }

  const defaultSorted = [
    {
      dataField: "categoryId",
      order: "asc",
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>View All Categories & Sub Categories | Flamingo</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Settings" breadcrumbItem="Category & Sub Category" />
          <Loader showLoader={showLoading} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={CategorySubCategoryColumns()}
                    data={categorySubCategoryList}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={categorySubCategoryList}
                        columns={CategorySubCategoryColumns()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className={classNames({"d-none": currentPage !== 1},"search-box me-2 d-inline-block")}>
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    onClick={() => {
                                      addNewItem('Category')
                                      setIsEdit(false)
                                    }}
                                    disabled={open}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Category
                                  </Button>
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    onClick={() => {
                                      addNewItem('Sub Category')
                                      setIsEdit(false)
                                    }}
                                    disabled={open}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Sub Category
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightDrawer 
          onClose={onDrawerClose} 
          currentItem={newItemToAdd} 
          onNewlyAddedValue={onNewlyAddedValue}
          categorySubCategoryMap={categorySubCategory}
          selectedId={null}
          detailsForEdit={detailsForEdit}
          isEdit={isEdit}
        />
      </ReactDrawer>
      {showDeletePopUp ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete()
          }}
          onCancel={() => {
            setShowDeletePopUp(false)
          }}
        >
          <p>{deleteMessage}</p>
          You won't be able to revert this!
        </SweetAlert>
      ) : null}
    </React.Fragment>
  )
}

CategorySubCategoryList.propTypes = {
  categorySubCategory: PropTypes.array,
  onGetCategoriesAndSubCategories: PropTypes.func,
}

export default withRouter(CategorySubCategoryList)
